// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__tibn5","employee-header-item":"Header_employee-header-item__7tfWm"};